export const URL_DEFAULT_LIMIT = 50;
export const GRID_PAGE_SIZES = [10, 25, 50, 100] as const;
export const PHONE_PAGE_SIZE = 8;
export const PHONE_PAGE_SIZES = [PHONE_PAGE_SIZE, ...GRID_PAGE_SIZES] as const;

export type ListWindow = { page: number; pageSize: number };

export function positiveInt(raw: string | null): number | undefined {
  if (!raw) return undefined;
  const n = Number(raw);
  return Number.isInteger(n) && n > 0 ? n : undefined;
}

export function readListWindow(
  params: URLSearchParams,
  sizes: readonly number[],
  ownDefault: number
): ListWindow {
  const page = positiveInt(params.get("page")) ?? 1;
  const limit = positiveInt(params.get("limit"));
  if (page === 1) {
    return { page: 1, pageSize: limit && sizes.includes(limit) ? limit : ownDefault };
  }
  const urlLimit = limit ?? URL_DEFAULT_LIMIT;
  if (sizes.includes(urlLimit)) return { page, pageSize: urlLimit };
  const pageSize = sizes.includes(URL_DEFAULT_LIMIT) ? URL_DEFAULT_LIMIT : ownDefault;
  const firstRow = (page - 1) * urlLimit;
  return { page: Math.floor(firstRow / pageSize) + 1, pageSize };
}

export function listWindowToParams(
  window: ListWindow,
  ownDefault: number
): { page: string | undefined; limit: string | undefined } {
  const paged = window.page > 1;
  return {
    page: paged ? String(window.page) : undefined,
    limit: paged || window.pageSize !== ownDefault ? String(window.pageSize) : undefined,
  };
}
